document.addEventListener("DOMContentLoaded", () => {
    const $body = document.querySelector('body'),
        $main = document.querySelector('main#main'),
        $header = document.querySelector('.page-header'),
        $menuBtn = document.querySelector('.js-menu-btn'),
        $mobileMenu = document.querySelector('.js-mobile-menu'),
        $bottomMobileMenu = document.querySelector('.js-bottom-mobile-cta'),
        $mobileOverlay = document.querySelector('.js-mob-overlay'),
        $utilityBar = document.querySelector('.js-utility-bar'),
        barHeight = $utilityBar ? $utilityBar.offsetHeight : 0;

    //Sticky-header
    function stickyHeader() {
        if($(window).scrollTop() > barHeight) {
            $header.classList.add('sticky');
        } else {
            $header.classList.remove('sticky');
        }
    }

    function calcTop() {
        const barHeight = $utilityBar ? $utilityBar.offsetHeight : 0,
            headerHeight = $header.offsetHeight;

        if($(window).scrollTop() > barHeight) {
            $header.style.top = 0;
            $mobileMenu.style.top = `${headerHeight}px`;
        } else {
            $header.style.top = `${barHeight}px`;
            $mobileMenu.style.top = `${barHeight + headerHeight}px`;
        }
    }

    // function calcMainMarginTop() {
    //     const barHeight = $utilityBar ? $utilityBar.offsetHeight : 0,
    //         headerHeight = $header.offsetHeight;
    //
    //     $main.style.marginTop = `${barHeight + headerHeight}px`;
    // }

    // function calcHeroHeight() {
    //     const $heroInner = document.querySelector('.js-hero-inner'),
    //         barHeight = $utilityBar ? $utilityBar.offsetHeight : 0,
    //         headerHeight = $header.offsetHeight;
    //
    //     if ($heroInner) {
    //         $heroInner.style.height = `calc(100vh - ${barHeight + headerHeight}px)`;
    //     }
    // }

    $menuBtn.addEventListener('click', () => {
        $body.classList.toggle('ov-hidden');
        $menuBtn.classList.toggle('open');
        $mobileMenu.classList.toggle('open');
        $bottomMobileMenu.classList.toggle('open');
        $mobileOverlay.classList.toggle('open');
    });

    if (window.innerWidth < 1280) {
        $('.mega-menu-item-has-children').children('.mega-menu-link').after(`
        <svg class="sub-menu-btn" xmlns="http://www.w3.org/2000/svg" width="16" height="9" viewBox="0 0 16 9" fill="none">
        <path d="M0.656378 0.65638L7.82812 7.82812L14.9999 0.656378" stroke="#3C3936"/>
        </svg>
        `);
        $('.mega-menu-item-has-children > .mega-sub-menu').addClass('main-sub-menu');
        $('.main-sub-menu').slideUp();

        $('.sub-menu-btn').on('click', function H(e) {
            e.preventDefault();
            $(this).siblings('.main-sub-menu').slideToggle();
            $(this).toggleClass('rotate');

            setTimeout(() => {
                let height = $('.js-mob-main-nav').height();

                const addRule = function(sheet, selector, styles) {
                    if (sheet.insertRule) return sheet.insertRule(selector + " {" + styles + "}", sheet.cssRules.length);
                    if (sheet.addRule) return sheet.addRule(selector, styles);
                };

                addRule(document.styleSheets[0].addRule(".js-mobile-menu::before", `height: ${height + 40}px!important;`));
                addRule(document.styleSheets[0].addRule(".js-mobile-menu::after", `height: ${height + 40}px!important;`));
            }, 500);
        });
    }

    // window.addEventListener('load', () => { calcTop(); calcMainMarginTop(); calcHeroHeight(); });
    //
    // window.addEventListener('resize', () => { calcTop(); calcMainMarginTop(); calcHeroHeight(); });

    document.addEventListener('scroll', () => { stickyHeader(); });
});
